import { createClient } from '@supabase/supabase-js';

function clean(value: unknown) {
  return String(value || '').replace(/^\uFEFF/, '').trim().replace(/^['"]|['"]$/g, '').replace(/\/+$/, '');
}

const url = clean(import.meta.env.VITE_SUPABASE_URL);
const key = clean(import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY);

export const configurationIssues: string[] = [];
if (!/^https:\/\/[a-z0-9-]+\.supabase\.co$/i.test(url)) configurationIssues.push('VITE_SUPABASE_URL is missing or malformed.');
if (!key || key.length < 20) configurationIssues.push('VITE_SUPABASE_PUBLISHABLE_KEY is missing or malformed.');

export const supabase = createClient(
  configurationIssues.length ? 'https://invalid-project.supabase.co' : url,
  configurationIssues.length ? 'invalid-publishable-key' : key,
  { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true } },
);
